/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_discover_errors_fetchprojects1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로젝트를 불러오는데 실패했습니다`)
};

const en_discover_errors_fetchprojects1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to fetch projects`)
};

const ja_discover_errors_fetchprojects1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの取得に失敗しました`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const discover_errors_fetchprojects1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discover_errors_fetchprojects1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discover_errors_fetchprojects1", locale)
	if (locale === "ko") return ko_discover_errors_fetchprojects1(inputs)
	if (locale === "en") return en_discover_errors_fetchprojects1(inputs)
	return ja_discover_errors_fetchprojects1(inputs)
};
export { discover_errors_fetchprojects1 as "discover_errors_fetchProjects" }